import { Card, CardBody, Row } from 'reactstrap'
import { useContactProfileFormSelectOptions } from '../../pages/Contacts/hooks'
import FormMainContainer from '../Common/FormMainContainer'
import FormSideContainer from '../Common/FormSideContainer'
import RecursiveForm from '../RecursiveForm'

const ContactProfileFormTab = (props) => {
    const { formik, inputs, subform, tabs, activeTab, handleTabChange, contactProfile, contactType } = props
    const { selectOptions, isPending: selectOptionsLoading } = useContactProfileFormSelectOptions(
        contactType,
        contactProfile?.contactProfileService?.id,
        contactProfile?.propertyType?.id
    )

    return (
        <>
            <Row>
                <FormSideContainer>
                    <Card>
                        <CardBody>
                            <RecursiveForm
                                inputs={inputs?.sideForm}
                                subform={subform}
                                formik={formik}
                                selectOptions={selectOptions}
                                selectOptionsLoading={selectOptionsLoading}
                            />
                        </CardBody>
                    </Card>
                </FormSideContainer>
                <FormMainContainer tabs={tabs} activeTab={activeTab} handleTabChange={handleTabChange}>
                    <RecursiveForm
                        inputs={inputs?.mainForm}
                        subform={subform}
                        formik={formik}
                        selectOptions={selectOptions}
                        selectOptionsLoading={selectOptionsLoading}
                    />
                </FormMainContainer>
            </Row>
        </>
    )
}

export default ContactProfileFormTab
